<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','overflow': 'hidden'}">
      <div>
        <img :src="loginBg1" style="width: 100%;height: 100%">
        <div class="landing">
            <div class="title2" style="margin-top:20px;color:#64748B ">{{ CONSTANTS.TEXTS.PROJECT_DESCRIPTION }}</div>
            <div class="title1">{{ CONSTANTS.TEXTS.PROJECT_NAME }}</div>
            <div class="form" >
                <div>
                  <input v-model="username" type="text" placeholder="用户名" autocapitalize="off" autocorrect="off">
                  <van-dropdown-menu v-show="cacheAccountList.length>0">
                    <van-dropdown-item @change="cacheAccountChange" v-model="value1" :options="option1" />
                  </van-dropdown-menu>
                </div>
                <div>
                  <div style="position: absolute;right: 50px;width: 30px;line-height: 40px;background: rgba(245,246,247,0);">
                    <img :src="show" width="30" v-if="type==='password'" @click="showPassword" />
                    <img :src="hide" width="30" v-if="type==='text'" @click="showPassword" />
                  </div>
                    <input v-model="password" ref="passwordRef" :type="type" placeholder="密码"  autocorrect="off">
                </div>
                <div class="code-box" style="margin-top:20px">
                    <input v-model="vrifyCode" type="text" placeholder="验证码" autocapitalize="off" autocorrect="off">
                    <div class="btn" @click="getImgCode"><img :src="imgCode" alt=""></div>
                </div>
                <div style="margin-top:20px">
                  <van-checkbox v-model="saveUP" shape="square">记住账号密码</van-checkbox>
                </div>

                <div class="login-btn" @click="toLogin">登录</div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Setting from '@/setting';
    import { Toast } from 'vant';
    import $ from '../utils/request'

    export default {
        data () {
            return {
                clientHeight: window.screen.height,
                username: '', // 用户名
                password: '', // 密码
                vrifyCode: '', // 验证码
                uuid: '', // 随机码
                imgCode: '', // 图片验证码
                loginBg: require('../assets/loginBg.png'),
                loginBg1: require('../assets/loginBg.svg'),
                hide: require('../assets/hide.png'),
                show: require('../assets/show.png'),
                type: 'password',
                userInfo: {},
                saveUP: false,
                cacheAccountList: [],
                value1: '',
                option1: [

                ],
            }
        },
        created () {
            this.getImgCode()
        },
        mounted() {
          this.userInfo = JSON.parse(localStorage.getItem('USER'));
          if(this.userInfo=={}||this.userInfo==undefined||this.userInfo==undefined||this.userInfo==''){
            this.saveUP = localStorage.getItem('saveUP')
            this.cacheAccountList = []
            const data = JSON.parse(localStorage.getItem('cacheAccountList'))
            if(data){
              this.cacheAccountList = data
            }
            if(this.cacheAccountList){
              for (let i = this.cacheAccountList.length-1; i >= 0 ; i--) {
                console.log('i',i)
                const item = {
                  text: this.cacheAccountList[i].username,
                  value: i
                }
                this.option1.push(item)
              }
            }

          }else{
            if(this.userInfo.roleName.includes('总管')){
              this.$router.push({name:'feature-reviewRecord'})
            }else{
              this.$router.push({name:'homepage'})
            }
          }

        },
      methods: {
            ...mapActions('admin/account', [
                'login'
            ]),
            showPassword(){
              if(this.type==='password'){
                this.type = 'text'
              }else{
                this.type = 'password'
              }
              this.$nextTick(()=>{
                this.$refs.passwordRef.focus()
              })


            },
            // 获取图形验证码
            getImgCode () {
                this.uuid = this.rand(1000, 9999);
                this.imgCode = `${Setting.apiBaseURL}kaptchaImage?uuid=${this.uuid}`;
            },
            // 登录
            toLogin () {
                let data = {}
                if (!this.username) {
                    Toast('请输入用户名');
                    return false;
                }
                if (!this.password) {
                    Toast('请输入密码');
                    return false;
                }
                if (!this.vrifyCode) {
                    Toast('请输入验证码');
                    return false;
                }
                data = {
                    username: this.username,
                    password: this.password,
                    vrifyCode: this.vrifyCode,
                    uuid: this.uuid,
                    wxopenid: localStorage.getItem('wxopenid')
                }
                this.login(data).then(res => {
                    /*// 重定向对象不存在则返回顶层路径
                    const roleName = res.roles[0]
                    switch (roleName) {
                    case '咨询顾问':
                        this.$router.replace({ name: 'homepage', params: { roleName: roleName } });
                        break;
                    case '项目负责人':
                        this.$router.replace({ name: 'homepage', params: { roleName: roleName } });
                        break;
                    default:
                        Toast('未授权访问角色');
                        break;
                    }*/
                  localStorage.setItem('saveUP',this.saveUP)
                  if(this.saveUP){
                    let cacheAccountList = JSON.parse(localStorage.getItem("cacheAccountList"))
                    if(cacheAccountList){
                      const account = {
                        username: this.username,
                        password: this.password,
                      }
                      let isExist = false
                      for (let i = 0; i < cacheAccountList.length; i++) {
                        if(cacheAccountList[i].username === this.username){
                          cacheAccountList[i].password = this.password
                          isExist = true
                        }
                      }
                      if(!isExist){
                        cacheAccountList.push(account)
                      }

                    }else{
                      cacheAccountList = []
                      const account = {
                        username: this.username,
                        password: this.password,
                      }
                      cacheAccountList.push(account)
                    }
                    localStorage.setItem('cacheAccountList',JSON.stringify(cacheAccountList))
                  }


                  $.get('/mobile/getProjectGroupByUserId/'+res.user.userId).then(res1=>{
                    localStorage.setItem('projectInfo',JSON.stringify(res1.data))
                  })

                  if(res.user.roleName.includes('总管')){
                    this.$router.push({name:'feature-reviewRecord'})
                  }else{
                    this.$router.push({name:'homepage'})
                  }
                }).catch((msg) => {
                    this.getImgCode()
                    this.vrifyCode = ''
                })
            },
            cacheAccountChange(e){
              console.log('change account',e)
              this.username = this.cacheAccountList[e].username
              this.password = this.cacheAccountList[e].password
            },
        }
    }
</script>

<style lang="less">

.landing {
        padding: 40px;
        width: 100%;
        position: fixed;
        top: 0px;
        .title1,.title2{
          text-align: center;
          color:#000000
        }
        .title1{
          font-weight: 800;
          font-size: 36px;
          line-height: 100px;
        }
        .title2{
          font-weight: 500;
          font-size: 28px;
          line-height: 60px;
        }
        .form{
          padding: 60px 40px;
          background-color: #FFFFFF;
          margin-top: 20px;
          border-radius: 5px;
        }
        input {
            display: block;
            margin-bottom: 0.32rem;
            width: 100%;
            height: 1.12rem;
            background: #f5f6f7;
            border: none;
            border-radius: 0.093rem;
            text-indent: 0.267rem;
            font-size: 0.373rem;
            color: #303234;
            @media (min-width: 768px) {
                margin-bottom: 0.2rem;
                height: 1rem;
            }
        }
        .code-box {
            background-color: #f5f6f7;
            input {
                display: inline-block;
                margin-bottom: 0;
                margin-right: 1%;
                width: 75%;
            }
            .btn {
                display: inline-block;
                width: 23%;
                line-height: 50px;
                border-radius: 10px;
                border: 1PX solid #bbb;
                background-color: #fff;
                font-size: 20px;
                text-align: center;
            }
        }
        .login-btn {
            margin-top: 1.333rem;
            display: block;
            width: 100%;
            height: 1.12rem;
            line-height: 1.12rem;
            border: none;
            background: #1B75F6;
            border-radius: 0.093rem;
            box-shadow: 0px 4px 24px 0px rgba(84, 195, 253, 0.153);
            font-size: 0.48rem;
            color: #fff;
            text-align: center;
            @media (min-width: 768px) {
                margin-top: 0.8rem;
                height: 1rem;
            }
        }
        @media (min-width: 768px) {
            padding: 48PX 64PX;
            div {
                font-size: 25.6PX;
                line-height: 54PX;
            }
            input {
                margin-bottom: 12PX;
                height: 60PX;
                border-radius: 5.6PX;
                text-indent: 16PX;
                font-size: 22.5PX;
            }
            .login-btn {
                margin-top: 48PX;
                height: 60PX;
                line-height: 60PX;
                border-radius: 5.6PX;
                box-shadow: 0px 4px 24px 0px rgba(84, 195, 253, 0.153);
                font-size: 25.6PX;
            }
        }
    }
    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }

</style>
<style lang="less" scoped>
/deep/.van-ellipsis{
  display: none!important;
}
/deep/.van-dropdown-menu{
  height: 15px !important;
  position: relative;
  left: 87%;
  top: -30px;
  background-color: rgba(0,0,0,0);
}
/deep/.van-dropdown-item__content{
  width: 80%;
  margin-left: 10%;
}
/deep/.van-overlay{
  display: none;
}
</style>
